<template>
  <div>
    <div class="tw-py-24 tw-text-3xl tw-font-bold tw-text-center" v-if="false">
      <div class="tw-py-4 tw-border-b tw-border-gray-600" v-if="props.timeWanted">
       props.timeWanted: {{props.timeWanted}}
      </div>
      <div class="tw-py-4 tw-border-b tw-border-gray-600" v-if="state.initialDate">
       initialDate: {{state.initialDate}}
      </div>
      <div class="tw-py-4 tw-border-b tw-border-gray-600" v-if="state.calendarDate">
       calendarDate: {{state.calendarDate!.toFormat('M/d h:mm a')}}
      </div>
      <div class="tw-py-4 tw-border-b tw-border-gray-600" v-if="state.date">
       date: {{state.date}}
      </div>
      <div class="tw-py-4 tw-border-b tw-border-gray-600" v-if="state.time">
       time: {{state.time}}
      </div>
      <div class="tw-py-4 tw-border-b tw-border-gray-600" v-if="state.minDate">
       minDate: {{state.minDate}}
      </div>
      <div class="tw-py-4 tw-border-b tw-border-gray-600" v-if="state.maxDate">
       maxDate: {{state.maxDate}}
      </div>

      <div class="tw-py-4 tw-border-b tw-border-gray-600" v-if="state.maxDate">
       disabledDates: {{state.disabledDates}}
      </div>

      <div class="tw-py-4 tw-border-b tw-border-gray-600" v-if="calculatedStartTime && calculatedEndTime">
       calculated start {{calculatedStartTime}} | end: {{calculatedEndTime}}
      </div>
    </div>

    <div class="lg:tw-flex">
      <div class="lg:tw-w-1/2 tw-flex tw-justify-center tw-items-center tw-px-8 lg:tw-px-24">
        <div class="tw-py-8 lg:tw-py-48 lg:tw-scale-125 tw-flex tw-flex-col">
          <div id="vuedatepicker-wrapper" class="tw-mx-auto">
            <VueDatePicker 
              v-model="state.date" 
              ref="datepicker"
              :hide-navigation="['year', 'time']"
              :month-change-on-scroll="false"
              :min-date="state.minDate"
              :max-date="state.maxDate"
              :disabled-dates="state.disabledDates"
              :week-start="0"
              inline 
              auto-apply></VueDatePicker>
          </div>
        </div>
      </div>

      <div class="lg:tw-w-1/2 lg:tw-border-l lg:tw-border-gray-300 tw-flex tw-items-center tw-px-8 tw-py-8 lg:tw-px-24 lg:tw-py-24">
        <div>
          <h2 class="tw-text-3xl tw-uppercase tw-font-bold tw-mb-8">{{ handoffMode == "pickup" ? "Pick Up" : "Drop-Off" }} Time</h2>
          <template v-if="state.loadingData">
            <SkeletonLoader class="tw-w-96 tw-h-16 tw-block tw-mb-12" />

            <SkeletonLoader class="tw-w-full tw-h-8 tw-block tw-mb-2" />
            <SkeletonLoader class="tw-w-1/3 tw-h-8 tw-block tw-mb-2" />
          </template>

          <template v-else>
            <template v-if="!calculatedStartTime || !calculatedEndTime">
              No times are available for the selected day.
            </template>
            <div class="tw-mb-4 tw-w-96" v-if="!state.loadingData && calculatedStartTime && typeof(calculatedStartTime) != 'undefined'">
              <TwTimePicker
                :value="state.time"
                :minTime="calculatedStartTime"
                :maxTime="calculatedEndTime"
                :selectedTime="state.time"
                :key="calculatedStartTime!.getTime() + calculatedEndTime!.getTime()"
                @onChange="setTime"
              />
            </div>
            <div class="tw-mb-12 tw-w-128 tw-text-orange-medium tw-text-2xl" v-if="state.time">
              This is your earliest {{ handoffMode == "pickup" ? "pick up" : "drop off" }} time. {{ handoffMode == "pickup" ? "Pick up" : "Drop off" }} time may be adjusted based on items in your bag.
            </div>
            <div class="tw-max-w-xl">
              <p v-if="calculatedTimeWanted && handoffModeString && props.selectedLocation">
                On <strong class="tw-text-3xl tw-font-black">{{weekdayString}} {{calculatedDateWanted}}</strong> at <strong class="tw-text-3xl tw-font-black">{{calculatedTimeWanted}}</strong>, {{ handoffModeString }} Piada {{props.selectedLocation.name}}.
              </p>
            </div>
          </template>
        </div>
      </div>
    </div>

    <TwModal
      v-show="state.showNextAvailable"
      :hasAccept="true"
      :hasHeader="false"
      @emitClose="state.showNextAvailable = false"
      >
      <template v-slot:body>
        <div class="tw-px-16 tw-pt-8">
          <template v-if="typeof(state.nextAvailable) != 'undefined'">
             <p class="tw-mb-16 tw-text-center tw-text-3xl">We're sorry, your order cannot be completed on the date you previously selected. The next available date is:</p>
         
          <div class="tw-text-center tw-px-4 tw-font-black tw-text-6xl">
            {{state.nextAvailable.toFormat('EEEE, MMMM d')}}
          </div>
          </template>

          <template v-else>
             <p class="tw-mb-16 tw-text-center tw-text-3xl">An error has occurred. No order times were available for the selected store. Please try again later.</p>
          </template>
        </div>
      </template>

      <template v-slot:footer>
        <div class="tw-flex tw-justify-center tw-items-center tw-px-8 tw-pt-12 tw-pb-16">
          <TwButton 
            cssClass="tw-bg-orange-medium tw-border-2 tw-border-orange-medium tw-text-white hover:tw-bg-black hover:tw-border-black tw-uppercase tw-font-bold tw-px-16 tw-py-3 tw-transition-all tw-duration-200 tw-ml-8 tw-rounded-full"
            @emit-click="state.showNextAvailable = false" 
            :isLoading="false"
            :isDisabled="false" 
            :buttonText="'Continue'"/>
        </div>
      </template>
    </TwModal>
  </div>
</template>

<script setup lang="ts">
  import {
    reactive, computed, watch, ref, onMounted, nextTick,
  } from 'vue';
  import { DateTime, Duration, Interval } from "luxon";
  import type { DatePickerInstance } from "@vuepic/vue-datepicker"

  import { useBasketStore } from '../../stores/basket';
  import { useFlashMessageStore } from '../../stores/flashMessages';

  import Location from '../../classes/Location';
  import type TimeOfDay from '../../types/TimeOfDay';
  import type Basket from '../../classes/Basket';
  import type RestaurantCalendar from "../../types/RestaurantCalendar"
  import type CalendarRange from "../../types/CalendarRange"
  import type FlashMessage from '../../types/FlashMessage';
  const flashMessageStore = useFlashMessageStore();

  import TwTimePicker from '../../components/TwTimePicker.vue'
  import SkeletonLoader from '../../components/SkeletonLoader.vue';
  import TwModal from '../../components/TwModal.vue'
  import TwButton from '../../components/TwButton.vue'

  const emit = defineEmits(['timeWantedSet'])

  const basketStore = useBasketStore();

  const datepicker = ref<DatePickerInstance>(null);

  const props = defineProps({
    handoffMode: String,
    selectedLocation: Location,
    guestCount: Number,
    editMode: Boolean,
    timeWanted: {
      type: Date
    },
  })

  const state = reactive({
    guestCount: 0,
    eventType: null,
    initialDate: undefined as (DateTime | undefined),
    minDate: DateTime.now().startOf('day').toJSDate(),
    maxDate: DateTime.now().plus({days: 7}).endOf('day').toJSDate(),
    date: undefined as (Date | undefined),
    calendarDate: undefined as (DateTime | undefined),
    nextAvailable: undefined as (DateTime | undefined),
    disabledDates: [] as Date[],
    showNextAvailable: false,
    loadingData: true,
    timeDirty: false,
    time: undefined as (Duration | undefined), // { "hours": 17, "minutes": 50, "seconds": 0 }
  })

  // ------------------------------------------------------------------------------------------
  //
  // Initialize
  //
  // ------------------------------------------------------------------------------------------

  onMounted(() => {
    // Update the basket so we have the most accurate times
    if (localStorage.getItem('mypiadaBasketId')) {
      basketStore.fetchBasketWithPromise(localStorage.getItem('mypiadaBasketId')!).then((basket: Basket) => {
        if (props.timeWanted) {
          state.initialDate = DateTime.fromJSDate(props.timeWanted);
        }

        initializeDates(basket);
        setMaxDate();
        disableClosedDates();

        removeLoader();   
      }).catch(() => {
        if (props.timeWanted) {
          state.initialDate = DateTime.fromJSDate(props.timeWanted);
        }

        initializeDates(undefined);
        setMaxDate();
        disableClosedDates();
        removeLoader();      
      })
    } else {
      initializeDates(undefined);
      setMaxDate();
      disableClosedDates();
      removeLoader();   
    }
  })

  const removeLoader = () => {
    nextTick(() => {
      // Give data time to populate after the next tick
      setTimeout(function() {
        state.loadingData = false;
      }, 300);
    })
  }

  const initializeDates = ((basket: (Basket | undefined)) => {
    // Get the first available time the order could potentially be placed
    let useDate = undefined as (DateTime | undefined);
    let nextAvailable = getEarliestReady(undefined);
    let setTimeFromOriginal = false;

    if (nextAvailable) {
      // Make sure the user's preselected time is acceptable
      if (state.initialDate) {
        if (nextAvailable.hasSame(state.initialDate,"day") || state.initialDate > nextAvailable) {
          useDate = DateTime.fromJSDate(state.initialDate.toJSDate()); // copy the original in case we need it untouched
          if (state.initialDate > nextAvailable) {
            setTimeFromOriginal = true;
          }
        } else {
          useDate = nextAvailable;
          state.nextAvailable = nextAvailable;
          state.showNextAvailable = true;
        }
      } else {
        useDate = nextAvailable;
      }

      state.calendarDate = useDate;
      state.date = useDate.toJSDate();
      state.minDate = nextAvailable.startOf('day').toJSDate();

      if (setTimeFromOriginal) {
        let start_of_day = useDate.startOf('day');
        let diff = useDate.diff(start_of_day, 'hours');

        let duration = diff.shiftTo('hours', 'minutes')
        state.time = (duration as any).values;
      }
    }
  })

  const disableClosedDates = () => {
    // Loop over the dates from start date to end date and remove any that don't have hours
    if (state.minDate != null && state.maxDate != null) {
      let start = DateTime.fromJSDate(state.minDate)
      let end = DateTime.fromJSDate(state.maxDate)

      const interval = Interval.fromDateTimes(
        start,
        end
      );

      const desiredArray = interval.splitBy({ days: 1 }).map((d) => d.start);

      let dDates = [] as Date[];
      desiredArray.forEach((d) => {
        let range = calendarRangeForDate(d!);
        if (range == null || typeof(range) == "undefined") {
          dDates.push(d!.toJSDate());
        }
      })

      state.disabledDates = dDates;
    }
  }


  // ------------------------------------------------------------------------------------------
  //
  // Calendar
  //
  // ------------------------------------------------------------------------------------------

  const currentCalendar = ((): RestaurantCalendar => {
    let cal = props.selectedLocation!.catering_calendar.find((cal: RestaurantCalendar) => {
      return cal.type == 'business'
    })

    // Grab the calendar for the actual handoff mode instead
    if (props.handoffMode && props.handoffMode != "pickup") {
      // Currently only supporting dispatch and pickup
      let newCal = props.selectedLocation!.catering_calendar.find((cal: RestaurantCalendar) => {
        return cal.type == 'dispatch';
      })
      if (newCal) {
        cal = newCal;
      }
    }

    return cal!;
  })

  const calendarRangeForDate = ((day: DateTime): CalendarRange => {
    const dayStr = day.toFormat('yyyyMMdd');
    const cal = currentCalendar();

    const calDay = cal!.ranges.filter((range: CalendarRange) => {
      return range.start.split(" ")[0] == dayStr;
    })

    return calDay[0]
  })

  // ------------------------------------------------------------------------------------------
  //
  // Earliest Ready 
  //
  // ------------------------------------------------------------------------------------------

  // Will loop over available days until it finds a day with available times, and return the earliest of those
  const getEarliestReady = ((beginningWith: (DateTime | undefined)): (DateTime | undefined) => {
    let cal = currentCalendar();
    let returnDate = undefined as (DateTime | undefined);

    if (cal) {
      cal.ranges.forEach((range: CalendarRange) => {
        let startTime = DateTime.fromFormat(range.start, 'yyyyMMdd HH:mm');
        if (typeof(beginningWith) == 'undefined' || startTime >= beginningWith) { 
          // Make sure the restaurant calendar date is the day of or after the user's already selected date if passed
          let st = earliestByCalendarRange(range);
          if (typeof(st) != "undefined" && typeof(returnDate) == "undefined") {
            // we're good, there are available times
            returnDate = st;
          }
        }
      })
    }
    // If no dates were found; the user is out of luck, should probably display a catastrophic message
    // This should only happen if the store calendar didn't load or the store is closed or something of
    // that nature
    return returnDate;
  })

  // Given a day's hours, will return the earliest in the day the order could be ready
  const earliestByCalendarRange = ((range: CalendarRange): (DateTime | undefined) => {
    const basket = basketStore.basket
    let cert = DateTime.now();
    let lmert = DateTime.now();
    let gert = DateTime.now();

    if (props.guestCount) {
      let requiredMinutes = 180 + ((props.guestCount - 10) * 1.25);
      gert = DateTime.now().plus({minutes: requiredMinutes});
    }

    // If the user has a basket already, we need to compare against the ealiest ready time
    if (basket) {
      lmert = DateTime.now().plus({minutes: basket.leadtimeestimateminutes});
      cert = basket.calculatedEarliestReadyTime(props.selectedLocation!);
    }

    if (range) { 
      let shert = DateTime.fromFormat(range.start, 'yyyyMMdd HH:mm');
      let storeClose = DateTime.fromFormat(range.end, 'yyyyMMdd HH:mm');
      let earliestQualified = DateTime.max(cert, gert, lmert, shert);

      // Check that the time is in the store range
      if (earliestQualified < storeClose) {
        return earliestQualified;
      } else {
        return undefined;
      }

    } else {
      return undefined;
    }
  })

  // ------------------------------------------------------------------------------------------
  //
  // Available Dates and Times
  //
  // ------------------------------------------------------------------------------------------

  const setMaxDate = () => {
    let maxDays = 3;

    if (props.selectedLocation && props.selectedLocation.cateringadvorderdays) {
      maxDays = props.selectedLocation!.cateringadvorderdays;
    }  

    state.maxDate = DateTime.now().plus({days: maxDays}).endOf('day').toJSDate();
  }

  const calculatedStartTime = computed(() => {
    if (state.calendarDate) {
      let earliest = getEarliestReady(state.calendarDate.startOf('day'));

      if (earliest) {
        return earliest.toJSDate();
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  })

  // Latest available time to be selectable
  const calculatedEndTime = computed(() => {
    if (state.calendarDate) {
      let range = calendarRangeForDate(state.calendarDate);

      if (range) { 
        let dt = DateTime.fromFormat(range.end, 'yyyyMMdd HH:mm');
        return dt.toJSDate();
      } else {
        return undefined;
      }
    } else {
      return undefined;
    }
  })


  // ------------------------------------------------------------------------------------------
  //
  // Computed Strings
  //
  // ------------------------------------------------------------------------------------------

  const weekdayString = computed(() => {
    if (state.calendarDate) {
      const dt = state.calendarDate.startOf('day');
      return dt.toFormat('cccc') + ",";
    } else {
      return "";
    }
  })


  const handoffModeString = computed(() => {
    if (props.handoffMode === "delivery") {
      return "your order will be delivered from "
    } else {
      return "you will pick up your order from "
    }
  })

  const calculatedDateWanted = computed(() => {
    if (state.date && state.time) {
      const dt = DateTime.fromJSDate(state.date).startOf('day');
      const sDate = dt.toFormat('MMMM d');
      return sDate;
    } else {
      return ""
    }
  })

  const calculatedTimeWanted = computed(() => {
    if (state.date && state.time) {
      const dt = DateTime.fromJSDate(state.date).startOf('day').plus(state.time);
      const sTime = dt.toFormat('h:mm a');
      return sTime;
    } else {
      return ""
    }
  })

  // ------------------------------------------------------------------------------------------
  //
  // Utilities and Emits
  //
  // ------------------------------------------------------------------------------------------

  watch(() => state.date, (newDate, oldDate) => {
    state.calendarDate = DateTime.fromJSDate(newDate as Date);
    setDate(newDate);
  })

  const errorFlash = (title: string, text: string) => {
    const message = {
      id: Math.round(Date.now() / 1000),
      messageType: "danger",
      text: text,
      headline: title,
      delay: 0, // ms
      icon: "",
      cssClass: "",
    } as FlashMessage;
    flashMessageStore.addMessage(message);
  }

  const emitDateTime = () => {
    if (state.date && state.time) {
      const dt = DateTime.fromJSDate(state.date).startOf('day').plus(state.time);
      emit('timeWantedSet', dt.toJSDate());
    }
  }

  const setTime = (newTime: Duration) => {
    state.time = newTime;
    state.timeDirty = true;
    emitDateTime()
  }

  const setDate = (newDate: any) => {
    emitDateTime()
  }
  
</script>

<style>
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }

  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }

  .dp__theme_light, .dp__theme_dark {
     --dp-background-color: #ffffff !important;
     --dp-text-color: #212121;
     --dp-hover-color: #212121;
     --dp-hover-text-color: #f48024;
     --dp-hover-icon-color: #959595;
     --dp-primary-color: #f48024 !important;
     --dp-primary-text-color: #f8f5f5;
     --dp-secondary-color: #c0c4cc;
     --dp-border-color: #ddd;
     --dp-menu-border-color: #ddd;
     --dp-border-color-hover: #aaaeb7;
     --dp-disabled-color: #f6f6f6 !important;
     --dp-scroll-bar-background: #f3f3f3;
     --dp-scroll-bar-color: #959595;
     --dp-success-color: #f48024 !important;
     --dp-success-color-disabled: #a3d9b1;
     --dp-icon-color: #959595;
     --dp-danger-color: #ff6f60;
     --dp-highlight-color: rgba(244, 128, 36, 0.3);
  }

  .dp__calendar_header_item{
    border: 4px solid white
  }

  .dp__calendar_header_item:nth-child(1),
  .dp__calendar_header_item:nth-child(7) {
    color: #000000;
    font-weight: bold;
    background-color: #fdecdf;
    border-radius: 0.5rem 0.5rem 0.5rem 0.5rem;
    border: 4px solid #fdecdf;
  }

</style>